export const getNews = (page?: number) => ({
  type: "@saga/GET_NEWS",
  payload: page,
});
